import React from 'react'; 
import RestrictionsContainer from './RestrictionsContainer.jsx';
import BundlesContainer from './bundles/BundlesContainer.jsx';
import DeactivateModalContainer from './bundles/DeactivateModalContainer.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const RestrictionsTab = () => (
  <div>
    <div className="flex center animated fadeIn">
      <div className="col-xs-12 col-lg-10">
        <ErrorListContainer />
      </div>
    </div>
    
    <BundlesContainer/>
    <DeactivateModalContainer />
    <RestrictionsContainer/> 
  </div>
);
 
export default RestrictionsTab;



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/RestrictionsTab.jsx